import {VIAF_URL, WIKIDATA_URL} from "../consts/khw-consts";

export const renderViafUrl = (viafId: string) => {
    return viafId.includes('http') ? viafId : `${VIAF_URL}/${viafId}`

}

export const renderWikidataUrl = (wikidataId: string) => `${WIKIDATA_URL}/${wikidataId}`
export const renderSubjectCategoryLink = (subjectCategory: string) => `${process.env.REACT_APP_KHW_DESCRIPTOR_LIST_URL}?subjectCategory=${subjectCategory}&descriptorType=subject_descriptor&sourceName=DBN&size=30&order=DESC&sortBy=CREATED_TIME&page=0`
